import { AB_TESTING_FLAGS } from '@/constants/analytics.constants';
import { Store } from '@/stores';
import { useAB } from '@tajawal/web-common/lib';
import { useState } from 'react';
import { useMapStoreStateToClientState } from './useMapStoreStateToClientState';

export function useNearbyAirportsSetup(store: Store) {
  const { active: isNearbyAirportBannerEnabled } = useAB(AB_TESTING_FLAGS.NEARBY_AIRPORTS_BANNER);
  const [shouldShowNearbyBanner, setShouldShowNearByBanner] = useState(true);

  const { hideNearbyAirports } = useMapStoreStateToClientState(store, (store: Store) => ({
    hideNearbyAirports: store.appStore.completeSearchPage.filterOutNearbyAirports,
  }));

  const handleHideNearBy = (shouldHide: boolean) => {
    if (shouldHide) {
      hideNearbyAirports();
    }
    setShouldShowNearByBanner(false);
  };

  return {
    shouldShowNearbyBanner: !!shouldShowNearbyBanner && !!isNearbyAirportBannerEnabled,
    handleHideNearBy,
  };
}
